var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgData = function SvgData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-616.000000, -558.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(407.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7777211,25.8098095 L11.5267391,32.110988 C11.8287128,32.6735853 12,33.3167895 12,34 C12,36.209139 10.209139,38 8,38 C5.790861,38 4,36.209139 4,34 C4,31.790861 5.790861,30 8,30 C8.42628869,30 8.83700243,30.0666843 9.22227887,30.1901905 L14.4732609,23.889012 C14.1712872,23.3264147 14,22.6832105 14,22 C14,19.790861 15.790861,18 18,18 C20.209139,18 22,19.790861 22,22 C22,22.3982165 21.9418092,22.7828418 21.8334671,23.1458364 L26.0409054,26.511787 C26.6199153,26.1858972 27.2882484,26 28,26 C28.3544934,26 28.6982163,26.0461139 29.0254973,26.1326703 L36.5747566,16.0669912 C36.209951,15.4637617 36,14.7563992 36,14 C36,11.790861 37.790861,10 40,10 C42.209139,10 44,11.790861 44,14 C44,16.209139 42.209139,18 40,18 C39.6455066,18 39.3017837,17.9538861 38.9745027,17.8673297 L31.4252434,27.9330088 C31.790049,28.5362383 32,29.2436008 32,30 C32,32.209139 30.209139,34 28,34 C25.790861,34 24,32.209139 24,30 C24,29.6017835 24.0581908,29.2171582 24.1665329,28.8541636 L19.9590946,25.488213 C19.3800847,25.8141028 18.7117516,26 18,26 C17.5737113,26 17.1629976,25.9333157 16.7777211,25.8098095 Z",
    fill: "#777776"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data.1539747c.svg";
export { ForwardRef as ReactComponent };